// frontend/src/pages/purchase/PurchaseOrders.jsx

import React, { useState, useEffect } from 'react';
import { getPurchaseOrders } from '../../utils/purchaseOrderApi';
import { getSuppliers } from '../../utils/supplierApi';
import { Link } from 'react-router-dom';

const PurchaseOrders = () => {
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      // 伝票一覧と仕入先一覧を同時に取得
      const [poData, supplierData] = await Promise.all([
        getPurchaseOrders(),
        getSuppliers()
      ]);
      setPurchaseOrders(poData);
      setSuppliers(supplierData);
    } catch (error) {
      console.error(error);
      alert('データの取得に失敗しました。');
    } finally {
      setLoading(false);
    }
  };

  // UUIDから仕入先名を検索する便利な関数
  const getSupplierName = (uuid) => {
    const supplier = suppliers.find(s => s.uuid === uuid);
    return supplier ? `[${supplier.supplier_code || '--'}] ${supplier.name}` : '不明な仕入先';
  };

  // ステータスの日本語表示変換
  const getStatusBadge = (status) => {
    switch (status) {
      case 'draft': return <span className="badge bg-secondary">下書き</span>;
      case 'ordered': return <span className="badge bg-primary">発注済</span>;
      case 'completed': return <span className="badge bg-success">入庫完了</span>;
      case 'cancelled': return <span className="badge bg-danger">キャンセル</span>;
      default: return <span className="badge bg-light text-dark">{status}</span>;
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="page-header mb-0">仕入伝票管理 <small>Purchase Orders</small></h1>
        <Link to="/purchase/purchase-orders/create" className="btn btn-success">
          <i className="fa fa-plus me-1"></i> 新規伝票作成
        </Link>
      </div>

      <div className="panel panel-inverse">
        <div className="panel-heading">
          <h4 className="panel-title">仕入伝票一覧</h4>
        </div>
        <div className="panel-body">
          {loading ? (
            <p>読み込み中...</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-bordered align-middle">
                <thead>
                  <tr>
                    <th width="15%">発注番号</th>
                    <th width="15%">発注日</th>
                    <th width="25%">仕入先</th>
                    <th width="15%">合計金額</th>
                    <th width="15%">ステータス</th>
                    <th width="15%" className="text-center">操作</th>
                  </tr>
                </thead>
                <tbody>
                  {purchaseOrders.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center">登録されている仕入伝票がありません。</td>
                    </tr>
                  ) : (
                    purchaseOrders.map((po) => (
                      <tr key={po.uuid}>
                        <td className="fw-bold">{po.order_number}</td>
                        <td>{new Date(po.order_date).toLocaleDateString()}</td>
                        <td>{getSupplierName(po.supplier_uuid)}</td>
                        <td className="text-end">¥{Number(po.total_amount).toLocaleString()}</td>
                        <td>{getStatusBadge(po.status)}</td>
                        <td className="text-center">
                          <Link to={`/purchase/purchase-orders/${po.uuid}`} className="btn btn-sm btn-white fw-bold shadow-sm border px-3">
                            <i className="fa fa-file-invoice text-primary me-1"></i>詳細
                          </Link>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrders;